import React from 'react'
import gql from 'graphql-tag'
import { CustomMetadata, Importance, RouteCoveragePolicy } from './index'
import { Mutation, MutationFn } from 'react-apollo'

export const settingsMutation = gql`
  mutation updateApplicationsSettings(
    $organizationID: ID!
    $autoLicense: Boolean!
    $filterAppMostRecentSession: Boolean!
    $preventOnboardingFailingApplications: Boolean!
    $preventOnboardingFailingApplicationsBySession: Boolean!
    $protectRuleEnv: String
    $routeExpirationDays: Int
    $remediationPolicies: [ID!]!
    $compliancePolicies: [ID!]!
    $importance: ApplicationImportance!
    $customMetadata: CustomMetadataInput!
    $routeCoverageAbsolutePolicy: RouteCoverageAbsolutePolicyInput
  ) {
    updateOrganizationApplicationsSettings(
      input: {
        organizationID: $organizationID
        settings: {
          autoLicense: $autoLicense
          filterAppMostRecentSession: $filterAppMostRecentSession
          preventOnboardingFailingApplications: $preventOnboardingFailingApplications
          preventOnboardingFailingApplicationsBySession: $preventOnboardingFailingApplicationsBySession
          protectRuleEnv: $protectRuleEnv
          routeExpirationDays: $routeExpirationDays
          remediationPolicies: $remediationPolicies
          compliancePolicies: $compliancePolicies
          importance: $importance
          customMetadata: $customMetadata
          routeCoverageAbsolutePolicy: $routeCoverageAbsolutePolicy
        }
      }
    ) {
      id
      importance
      autoLicense
      filterAppMostRecentSession
      preventOnboardingFailingApplications
      preventOnboardingFailingApplicationsBySession
      routeExpirationDays
      remediationPolicies {
        id
        name
      }
      compliancePolicies {
        id
        name
      }
      routeCoverageAbsolutePolicy {
        id
        name
        coveragePercentage
        enabled
        applicationImportances
        applicationIds
        allApplications
      }
    }
  }
`

interface SettingsMutationArgs {
  readonly organizationID: string
  readonly autoLicense: boolean
  readonly filterAppMostRecentSession: boolean
  readonly preventOnboardingFailingApplicationsn: boolean
  readonly preventOnboardingFailingApplicationsBySessionn: boolean
  protectRuleEnv: string
  routeExpirationDays: number | null
  readonly remediationPolicies: string[]
  readonly compliancePolicies: string[]
  readonly importance: Importance
  readonly customMetadata: CustomMetadata
  routeCoverageAbsolutePolicy: RouteCoveragePolicy | null
}

export function OrganizationSettingsMutation({
  children
}: {
  readonly children: (
    updateSettings: MutationFn<{}, SettingsMutationArgs>
  ) => React.ReactNode
}) {
  return (
    <Mutation<{}, SettingsMutationArgs> mutation={settingsMutation}>
      {(updateSettings) => {
        return children(updateSettings)
      }}
    </Mutation>
  )
}
